import { styled } from '@mui/material';

const CheckboxWrapper = styled('div')<{ $centeredLabel?: boolean }>`
  position: relative;
  display: inline-block;

  & > label {
    align-items: ${({ $centeredLabel }) =>
      $centeredLabel ? 'center' : 'flex-start'};
    margin-right: 0;

    & > .MuiTypography-root {
      margin-top: 1px;
    }
  }
`;

export default CheckboxWrapper;
